module.exports = __webpack_public_path__ + "img/framenew_box24.357caacb.jpg";